import { RootState } from "../rootStore";
export const selectAtheletesList = ({ athletes }: RootState) =>
  athletes.atheletesList;

  export const selectTotalAtheletes = ({ athletes }: RootState) =>
  athletes.totalAthletesList;

  export const selectLoadingAtheletes = ({ athletes }: RootState) =>
  athletes.loadingAtheletes;

export const selectAthletesCurrentPage = ({ athletes }: RootState) =>
  athletes.limitAtheletesList > 0
    ? Math.floor(athletes.offsetAthletesList / athletes.limitAtheletesList) + 1
    : 1;

export const selectAthletesTotalPages = ({ athletes }: RootState) =>
  athletes.limitAtheletesList > 0
    ? Math.ceil(athletes.totalAthletesList / athletes.limitAtheletesList)
    : 1;
